import { NSSwitch } from 'bricks';
import AddColumns from './AddColumns/AddColumns';
import SelectedColumns from './SelectedColumns/SelectedColumns';

interface IAttributesProps {
    className?: string;
    selectedColumns: string[];
    setSelectedColumns: (columns: string[]) => void;
    permanentColumns?: string[];
    includeMap: boolean;
    setIncludeMap: (value: boolean) => void;
}
const Attributes = ({
    className,
    selectedColumns,
    setSelectedColumns,
    permanentColumns,
    includeMap,
    setIncludeMap,
}: IAttributesProps) => (
    <div className={`Attributes d-flex flex-column ${className}`}>
        <div className="d-flex align-items-center justify-content-between mt-4">
            <div className="d-flex flex-column">
                <span className="text-white font-weight-semibold">Include map</span>
                <span className="text-muted font-12">Show deal locations at top of report</span>
            </div>
            <NSSwitch
                id="includeMapToggle"
                name="includeMapToggle"
                checked={includeMap}
                onChange={event => setIncludeMap(event.target.checked)}
                ariaLabel="Include map"
                data-testid="include-map-toggle"
            />
        </div>
        <SelectedColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} permanentColumns={permanentColumns} />
        <hr />
        <AddColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} />
    </div>
);

export default Attributes;
